import { Converter } from '../types/converter';

export const currentConverter: Converter = {
  id: 'current',
  name: 'Current Converter',
  icon: 'Zap',
  categories: ['electricity'],
  units: [
    // SI unit
    { name: 'Ampere', symbol: 'A', factor: 1 },
    { name: 'Kiloampere', symbol: 'kA', factor: 1000 },
    { name: 'Milliampere', symbol: 'mA', factor: 0.001 },
    
    // CGS units
    { name: 'Biot', symbol: 'Bi', factor: 10 },
    { name: 'Abampere', symbol: 'abA', factor: 10 },
    { name: 'EMU of current', symbol: 'EMU', factor: 10 },
    { name: 'Statampere', symbol: 'stA', factor: 3.335641e-10 },
    { name: 'ESU of current', symbol: 'ESU', factor: 3.335641e-10 },
    { name: 'CGS e.m. unit', symbol: 'CGS e.m.', factor: 10 },
    { name: 'CGS e.s. unit', symbol: 'CGS e.s.', factor: 3.335641e-10 }
  ]
};
